<template lang="html">
  <h1>SIGNOUT</h1>
</template>

<script>
import { SIGNOUT,LOGOUT } from '@/store/mutation-types'

export default {
  name: 'Signout',

  mounted () {
    this.$http.get('sexymm/logout').then(
      this.signout, this.signout
      
    )
  },

 

  methods: {
    signout () {
      this.$store.commit(SIGNOUT)
       this.$store.commit(LOGOUT)
      window.location.replace('/#/play');
    }
  }
}
</script>
